import { render, staticRenderFns } from "./TheGlobalModalHeader.vue?vue&type=template&id=e86c1524"
import script from "./TheGlobalModalHeader.vue?vue&type=script&lang=ts"
export * from "./TheGlobalModalHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports